import '../../assets/index36.css';var j = Object.defineProperty, Y = Object.defineProperties;
var M = Object.getOwnPropertyDescriptors;
var A = Object.getOwnPropertySymbols;
var E = Object.prototype.hasOwnProperty, W = Object.prototype.propertyIsEnumerable;
var T = (e, t, o) => t in e ? j(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o, a = (e, t) => {
  for (var o in t || (t = {}))
    E.call(t, o) && T(e, o, t[o]);
  if (A)
    for (var o of A(t))
      W.call(t, o) && T(e, o, t[o]);
  return e;
}, i = (e, t) => Y(e, M(t));
var k = (e, t) => {
  var o = {};
  for (var r in e)
    E.call(e, r) && t.indexOf(r) < 0 && (o[r] = e[r]);
  if (e != null && A)
    for (var r of A(e))
      t.indexOf(r) < 0 && W.call(e, r) && (o[r] = e[r]);
  return o;
};
import { jsx as s, jsxs as g } from "react/jsx-runtime";
import Z from "react";
import { Flex as G } from "../Flex/index.js";
import { Text as J } from "../Text/index.js";
import { ProgressIndicator as K } from "../ProgressIndicator/index.js";
import { Button as S } from "../Button/index.js";
import { CheckCircleFarFAIcon as L, TriangleExclamationFarFAIcon as V, CircleInfoFarFAIcon as X, CircleExclamationFarFAIcon as q, XMarkFarFAIcon as H } from "../Icons/index.js";
import { f as O, u as Q, B as U, b as ee } from "../../factory-ueRxoNOV.js";
import { r as z } from "../../rem-CMQJ_ZTp.js";
import { e as oe } from "../../get-size-Bc1Pz5yf.js";
import { c as te } from "../../create-vars-resolver-Bzbn9G-G.js";
import { u as re } from "../../use-styles-DToiHEa6.js";
import { C as se } from "../../CloseButton-BysQSF2E.js";
import { u as ae } from "../../use-id-D2tGiO9x.js";
var P = { root: "m_66836ed3", wrapper: "m_a5d60502", body: "m_667c2793", title: "m_6a03f287", label: "m_698f4f23", icon: "m_667f2a6a", message: "m_7fa78076", closeButton: "m_87f54839" };
const ie = {}, le = te(
  (e, { radius: t, color: o, variant: r, autoContrast: _ }) => {
    const n = e.variantColorResolver({
      color: o || e.primaryColor,
      theme: e,
      variant: r || "light",
      autoContrast: _
    });
    return {
      root: {
        "--alert-radius": t === void 0 ? void 0 : oe(t),
        "--alert-bg": o || r ? n.background : void 0,
        "--alert-color": n.color,
        "--alert-bd": o || r ? n.border : void 0
      }
    };
  }
), F = O((e, t) => {
  const o = Q("Alert", ie, e), R = o, {
    classNames: r,
    className: _,
    style: n,
    styles: C,
    unstyled: b,
    vars: y,
    radius: p,
    color: I,
    title: f,
    children: w,
    id: v,
    icon: u,
    withCloseButton: c,
    onClose: d,
    closeButtonLabel: B,
    variant: h,
    autoContrast: be
  } = R, $ = k(R, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "radius",
    "color",
    "title",
    "children",
    "id",
    "icon",
    "withCloseButton",
    "onClose",
    "closeButtonLabel",
    "variant",
    "autoContrast"
  ]), m = re({
    name: "Alert",
    classes: P,
    props: o,
    className: _,
    style: n,
    classNames: r,
    styles: C,
    unstyled: b,
    vars: y,
    varsResolver: le
  }), x = ae(v), D = f && `${x}-title` || void 0, N = `${x}-body`;
  return /* @__PURE__ */ s(
    U,
    i(a(i(a({
      id: x
    }, m("root", { variant: h })), {
      variant: h,
      ref: t
    }), $), {
      role: "alert",
      "aria-describedby": N,
      "aria-labelledby": D,
      children: /* @__PURE__ */ g("div", i(a({}, m("wrapper")), { children: [
        u && /* @__PURE__ */ s("div", i(a({}, m("icon")), { children: u })),
        /* @__PURE__ */ g("div", i(a({}, m("body")), { children: [
          f && /* @__PURE__ */ s("div", i(a({}, m("title")), { "data-with-close-button": c || void 0, children: /* @__PURE__ */ s("span", i(a({ id: D }, m("label")), { children: f })) })),
          w && /* @__PURE__ */ s("div", i(a({ id: N }, m("message")), { "data-variant": h, children: w }))
        ] })),
        c && /* @__PURE__ */ s(
          se,
          i(a({}, m("closeButton")), {
            onClick: d,
            variant: "transparent",
            size: 16,
            iconSize: 16,
            "aria-label": B,
            unstyled: b
          })
        )
      ] }))
    })
  );
});
F.classes = P;
F.displayName = "@mantine/core/Alert";
const ne = "Alert-module__flex___YYwWE", ce = "Alert-module__iconWithTitle___5pESz", de = "Alert-module__message___J9-hZ", me = "Alert-module__root___W6eAf", _e = "Alert-module__buttonsContainer___ibZ8r", ue = "Alert-module__title___7epKE", pe = "Alert-module__wrapper___RPRmA", fe = "Alert-module__hasDismiss___ihCzE", he = "Alert-module__hasDismissAction___pThGY", l = {
  flex: ne,
  iconWithTitle: ce,
  message: de,
  root: me,
  buttonsContainer: _e,
  title: ue,
  wrapper: pe,
  hasDismiss: fe,
  hasDismissAction: he
}, Te = Z.forwardRef((w, f) => {
  var v = w, {
    action: e,
    actionLabel: t,
    children: o,
    onClose: r,
    title: _,
    variant: n = "info",
    className: C,
    width: b,
    "data-plum-id": y,
    size: p = "md"
  } = v, I = k(v, [
    "action",
    "actionLabel",
    "children",
    "onClose",
    "title",
    "variant",
    "className",
    "width",
    "data-plum-id",
    "size"
  ]);
  const u = ee(), c = p === "sm" ? z(14) : p === "lg" ? z(16) : z(16);
  let d;
  switch (n) {
    case "error":
      d = /* @__PURE__ */ s(q, { color: u.colors.red[5], filled: !0, size: c });
      break;
    case "info":
      d = /* @__PURE__ */ s(X, { color: u.colors.blue[6], filled: !0, size: c });
      break;
    case "warning":
      d = /* @__PURE__ */ s(V, { color: u.colors.orange[5], filled: !0, size: c });
      break;
    case "success":
      d = /* @__PURE__ */ s(L, { color: u.colors.green[6], filled: !0, size: c });
      break;
    case "loading":
      d = /* @__PURE__ */ s(K, { size: c });
      break;
  }
  const B = _ ? /* @__PURE__ */ s(J, { size: "md", prominent: !0, className: l.title, "data-size": p, children: _ }) : void 0, h = [
    C || "",
    r ? l.hasDismiss : "",
    e && r ? l.hasDismissAction : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ s(
    F,
    i(a({}, I), {
      classNames: {
        closeButton: l.closeButton,
        icon: _ ? l.iconWithTitle : void 0,
        message: l.message,
        root: l.root,
        wrapper: l.wrapper
      },
      title: B,
      className: h,
      style: { width: b },
      "data-plum-id": y,
      icon: d,
      ref: f,
      "data-variant": n,
      "data-size": p,
      withCloseButton: !1,
      children: /* @__PURE__ */ g(G, { className: l.flex, "data-size": p, children: [
        o,
        /* @__PURE__ */ g("div", { className: l.buttonsContainer, children: [
          e && /* @__PURE__ */ s(
            S,
            {
              "data-plum-id": "alert-action-button",
              onClick: e,
              variant: "secondary",
              children: t
            }
          ),
          r && /* @__PURE__ */ s(
            S,
            {
              onClick: r,
              variant: "tertiary",
              size: "sm",
              children: /* @__PURE__ */ s(H, {})
            }
          )
        ] })
      ] })
    })
  );
});
export {
  Te as Alert
};
